import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { VesselClassPayload, VesselClassResponse } from "@/types/interface/vessel-class";

export const useVesselClass = defineStore("vesselClassStore", () => {
  const vesselClass = ref<VesselClassResponse>();
  const vesselClassList = ref<VesselClassResponse[]>([]);

  function initVesselClass(data: any) {
    vesselClassList.value = data?.data;
  }

  function addNewVesselClass(data: any) {
    vesselClass.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselClass.getVesselClass(page, limit, queryParam);
      if (status === 200 ) {
        initVesselClass(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idVeselType = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselClass.findVesselClass(idVeselType);
      if (status === 200 ) {
        addNewVesselClass(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: VesselClassPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselClass.createVesselClass(payload);
      if (status === 200 ) {
        addNewVesselClass(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idVeselType = "", payload: VesselClassPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselClass.updateVesselClass(idVeselType, payload);
      if (status === 200 ) {
        addNewVesselClass(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idVeselType = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselClass.deleteVesselClass(idVeselType);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    vesselClass,
    vesselClassList,
    initVesselClass,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});